/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Page2RouteImport } from './routes/page-2'
import { Route as MockLoginGatewayRouteImport } from './routes/mock-login-gateway'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevtoolsRouteImport } from './routes/devtools'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleSmartbankingRouteImport } from './routes/$locale/smartbanking'
import { Route as LocaleSmartbankingIndexRouteImport } from './routes/$locale/smartbanking/index'
import { Route as LocaleSmartbankingTurnoversRouteImport } from './routes/$locale/smartbanking/turnovers'
import { Route as LocaleSmartbankingTemplatesRouteImport } from './routes/$locale/smartbanking/templates'
import { Route as LocaleSmartbankingSettingsRouteImport } from './routes/$locale/smartbanking/settings'
import { Route as LocaleSmartbankingSavingsRouteImport } from './routes/$locale/smartbanking/savings'
import { Route as LocaleSmartbankingProfileRouteImport } from './routes/$locale/smartbanking/profile'
import { Route as LocaleSmartbankingPaymentsRouteImport } from './routes/$locale/smartbanking/payments'
import { Route as LocaleSmartbankingMessagesRouteImport } from './routes/$locale/smartbanking/messages'
import { Route as LocaleSmartbankingInvestmentsRouteImport } from './routes/$locale/smartbanking/investments'
import { Route as LocaleSmartbankingInfoRouteImport } from './routes/$locale/smartbanking/info'
import { Route as LocaleSmartbankingDocumentsRouteImport } from './routes/$locale/smartbanking/documents'
import { Route as LocaleSmartbankingDashboardRouteImport } from './routes/$locale/smartbanking/dashboard'
import { Route as LocaleSmartbankingContactsRouteImport } from './routes/$locale/smartbanking/contacts'
import { Route as LocaleSmartbankingCardsRouteImport } from './routes/$locale/smartbanking/cards'
import { Route as LocaleSmartbankingPaymentsIndexRouteImport } from './routes/$locale/smartbanking/payments/index'
import { Route as LocaleSmartbankingPaymentsPaymentIdRouteImport } from './routes/$locale/smartbanking/payments/$paymentId'

const Page2Route = Page2RouteImport.update({
  id: '/page-2',
  path: '/page-2',
  getParentRoute: () => rootRouteImport,
} as any)
const MockLoginGatewayRoute = MockLoginGatewayRouteImport.update({
  id: '/mock-login-gateway',
  path: '/mock-login-gateway',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevtoolsRoute = DevtoolsRouteImport.update({
  id: '/devtools',
  path: '/devtools',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSmartbankingRoute = LocaleSmartbankingRouteImport.update({
  id: '/smartbanking',
  path: '/smartbanking',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSmartbankingIndexRoute = LocaleSmartbankingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleSmartbankingRoute,
} as any)
const LocaleSmartbankingTurnoversRoute =
  LocaleSmartbankingTurnoversRouteImport.update({
    id: '/turnovers',
    path: '/turnovers',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingTemplatesRoute =
  LocaleSmartbankingTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingSettingsRoute =
  LocaleSmartbankingSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingSavingsRoute =
  LocaleSmartbankingSavingsRouteImport.update({
    id: '/savings',
    path: '/savings',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingProfileRoute =
  LocaleSmartbankingProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingPaymentsRoute =
  LocaleSmartbankingPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingMessagesRoute =
  LocaleSmartbankingMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingInvestmentsRoute =
  LocaleSmartbankingInvestmentsRouteImport.update({
    id: '/investments',
    path: '/investments',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingInfoRoute = LocaleSmartbankingInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => LocaleSmartbankingRoute,
} as any)
const LocaleSmartbankingDocumentsRoute =
  LocaleSmartbankingDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingDashboardRoute =
  LocaleSmartbankingDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingContactsRoute =
  LocaleSmartbankingContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => LocaleSmartbankingRoute,
  } as any)
const LocaleSmartbankingCardsRoute = LocaleSmartbankingCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => LocaleSmartbankingRoute,
} as any)
const LocaleSmartbankingPaymentsIndexRoute =
  LocaleSmartbankingPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleSmartbankingPaymentsRoute,
  } as any)
const LocaleSmartbankingPaymentsPaymentIdRoute =
  LocaleSmartbankingPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => LocaleSmartbankingPaymentsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/devtools': typeof DevtoolsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mock-login-gateway': typeof MockLoginGatewayRoute
  '/page-2': typeof Page2Route
  '/$locale/smartbanking': typeof LocaleSmartbankingRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/smartbanking/cards': typeof LocaleSmartbankingCardsRoute
  '/$locale/smartbanking/contacts': typeof LocaleSmartbankingContactsRoute
  '/$locale/smartbanking/dashboard': typeof LocaleSmartbankingDashboardRoute
  '/$locale/smartbanking/documents': typeof LocaleSmartbankingDocumentsRoute
  '/$locale/smartbanking/info': typeof LocaleSmartbankingInfoRoute
  '/$locale/smartbanking/investments': typeof LocaleSmartbankingInvestmentsRoute
  '/$locale/smartbanking/messages': typeof LocaleSmartbankingMessagesRoute
  '/$locale/smartbanking/payments': typeof LocaleSmartbankingPaymentsRouteWithChildren
  '/$locale/smartbanking/profile': typeof LocaleSmartbankingProfileRoute
  '/$locale/smartbanking/savings': typeof LocaleSmartbankingSavingsRoute
  '/$locale/smartbanking/settings': typeof LocaleSmartbankingSettingsRoute
  '/$locale/smartbanking/templates': typeof LocaleSmartbankingTemplatesRoute
  '/$locale/smartbanking/turnovers': typeof LocaleSmartbankingTurnoversRoute
  '/$locale/smartbanking/': typeof LocaleSmartbankingIndexRoute
  '/$locale/smartbanking/payments/$paymentId': typeof LocaleSmartbankingPaymentsPaymentIdRoute
  '/$locale/smartbanking/payments/': typeof LocaleSmartbankingPaymentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/devtools': typeof DevtoolsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mock-login-gateway': typeof MockLoginGatewayRoute
  '/page-2': typeof Page2Route
  '/$locale': typeof LocaleIndexRoute
  '/$locale/smartbanking/cards': typeof LocaleSmartbankingCardsRoute
  '/$locale/smartbanking/contacts': typeof LocaleSmartbankingContactsRoute
  '/$locale/smartbanking/dashboard': typeof LocaleSmartbankingDashboardRoute
  '/$locale/smartbanking/documents': typeof LocaleSmartbankingDocumentsRoute
  '/$locale/smartbanking/info': typeof LocaleSmartbankingInfoRoute
  '/$locale/smartbanking/investments': typeof LocaleSmartbankingInvestmentsRoute
  '/$locale/smartbanking/messages': typeof LocaleSmartbankingMessagesRoute
  '/$locale/smartbanking/profile': typeof LocaleSmartbankingProfileRoute
  '/$locale/smartbanking/savings': typeof LocaleSmartbankingSavingsRoute
  '/$locale/smartbanking/settings': typeof LocaleSmartbankingSettingsRoute
  '/$locale/smartbanking/templates': typeof LocaleSmartbankingTemplatesRoute
  '/$locale/smartbanking/turnovers': typeof LocaleSmartbankingTurnoversRoute
  '/$locale/smartbanking': typeof LocaleSmartbankingIndexRoute
  '/$locale/smartbanking/payments/$paymentId': typeof LocaleSmartbankingPaymentsPaymentIdRoute
  '/$locale/smartbanking/payments': typeof LocaleSmartbankingPaymentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/devtools': typeof DevtoolsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mock-login-gateway': typeof MockLoginGatewayRoute
  '/page-2': typeof Page2Route
  '/$locale/smartbanking': typeof LocaleSmartbankingRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/smartbanking/cards': typeof LocaleSmartbankingCardsRoute
  '/$locale/smartbanking/contacts': typeof LocaleSmartbankingContactsRoute
  '/$locale/smartbanking/dashboard': typeof LocaleSmartbankingDashboardRoute
  '/$locale/smartbanking/documents': typeof LocaleSmartbankingDocumentsRoute
  '/$locale/smartbanking/info': typeof LocaleSmartbankingInfoRoute
  '/$locale/smartbanking/investments': typeof LocaleSmartbankingInvestmentsRoute
  '/$locale/smartbanking/messages': typeof LocaleSmartbankingMessagesRoute
  '/$locale/smartbanking/payments': typeof LocaleSmartbankingPaymentsRouteWithChildren
  '/$locale/smartbanking/profile': typeof LocaleSmartbankingProfileRoute
  '/$locale/smartbanking/savings': typeof LocaleSmartbankingSavingsRoute
  '/$locale/smartbanking/settings': typeof LocaleSmartbankingSettingsRoute
  '/$locale/smartbanking/templates': typeof LocaleSmartbankingTemplatesRoute
  '/$locale/smartbanking/turnovers': typeof LocaleSmartbankingTurnoversRoute
  '/$locale/smartbanking/': typeof LocaleSmartbankingIndexRoute
  '/$locale/smartbanking/payments/$paymentId': typeof LocaleSmartbankingPaymentsPaymentIdRoute
  '/$locale/smartbanking/payments/': typeof LocaleSmartbankingPaymentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/devtools'
    | '/login'
    | '/logout'
    | '/mock-login-gateway'
    | '/page-2'
    | '/$locale/smartbanking'
    | '/$locale/'
    | '/$locale/smartbanking/cards'
    | '/$locale/smartbanking/contacts'
    | '/$locale/smartbanking/dashboard'
    | '/$locale/smartbanking/documents'
    | '/$locale/smartbanking/info'
    | '/$locale/smartbanking/investments'
    | '/$locale/smartbanking/messages'
    | '/$locale/smartbanking/payments'
    | '/$locale/smartbanking/profile'
    | '/$locale/smartbanking/savings'
    | '/$locale/smartbanking/settings'
    | '/$locale/smartbanking/templates'
    | '/$locale/smartbanking/turnovers'
    | '/$locale/smartbanking/'
    | '/$locale/smartbanking/payments/$paymentId'
    | '/$locale/smartbanking/payments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/devtools'
    | '/login'
    | '/logout'
    | '/mock-login-gateway'
    | '/page-2'
    | '/$locale'
    | '/$locale/smartbanking/cards'
    | '/$locale/smartbanking/contacts'
    | '/$locale/smartbanking/dashboard'
    | '/$locale/smartbanking/documents'
    | '/$locale/smartbanking/info'
    | '/$locale/smartbanking/investments'
    | '/$locale/smartbanking/messages'
    | '/$locale/smartbanking/profile'
    | '/$locale/smartbanking/savings'
    | '/$locale/smartbanking/settings'
    | '/$locale/smartbanking/templates'
    | '/$locale/smartbanking/turnovers'
    | '/$locale/smartbanking'
    | '/$locale/smartbanking/payments/$paymentId'
    | '/$locale/smartbanking/payments'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/devtools'
    | '/login'
    | '/logout'
    | '/mock-login-gateway'
    | '/page-2'
    | '/$locale/smartbanking'
    | '/$locale/'
    | '/$locale/smartbanking/cards'
    | '/$locale/smartbanking/contacts'
    | '/$locale/smartbanking/dashboard'
    | '/$locale/smartbanking/documents'
    | '/$locale/smartbanking/info'
    | '/$locale/smartbanking/investments'
    | '/$locale/smartbanking/messages'
    | '/$locale/smartbanking/payments'
    | '/$locale/smartbanking/profile'
    | '/$locale/smartbanking/savings'
    | '/$locale/smartbanking/settings'
    | '/$locale/smartbanking/templates'
    | '/$locale/smartbanking/turnovers'
    | '/$locale/smartbanking/'
    | '/$locale/smartbanking/payments/$paymentId'
    | '/$locale/smartbanking/payments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRoute: typeof LocaleRouteWithChildren
  DevtoolsRoute: typeof DevtoolsRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  MockLoginGatewayRoute: typeof MockLoginGatewayRoute
  Page2Route: typeof Page2Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/page-2': {
      id: '/page-2'
      path: '/page-2'
      fullPath: '/page-2'
      preLoaderRoute: typeof Page2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mock-login-gateway': {
      id: '/mock-login-gateway'
      path: '/mock-login-gateway'
      fullPath: '/mock-login-gateway'
      preLoaderRoute: typeof MockLoginGatewayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devtools': {
      id: '/devtools'
      path: '/devtools'
      fullPath: '/devtools'
      preLoaderRoute: typeof DevtoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/': {
      id: '/$locale/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/smartbanking': {
      id: '/$locale/smartbanking'
      path: '/smartbanking'
      fullPath: '/$locale/smartbanking'
      preLoaderRoute: typeof LocaleSmartbankingRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/smartbanking/': {
      id: '/$locale/smartbanking/'
      path: '/'
      fullPath: '/$locale/smartbanking/'
      preLoaderRoute: typeof LocaleSmartbankingIndexRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/turnovers': {
      id: '/$locale/smartbanking/turnovers'
      path: '/turnovers'
      fullPath: '/$locale/smartbanking/turnovers'
      preLoaderRoute: typeof LocaleSmartbankingTurnoversRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/templates': {
      id: '/$locale/smartbanking/templates'
      path: '/templates'
      fullPath: '/$locale/smartbanking/templates'
      preLoaderRoute: typeof LocaleSmartbankingTemplatesRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/settings': {
      id: '/$locale/smartbanking/settings'
      path: '/settings'
      fullPath: '/$locale/smartbanking/settings'
      preLoaderRoute: typeof LocaleSmartbankingSettingsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/savings': {
      id: '/$locale/smartbanking/savings'
      path: '/savings'
      fullPath: '/$locale/smartbanking/savings'
      preLoaderRoute: typeof LocaleSmartbankingSavingsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/profile': {
      id: '/$locale/smartbanking/profile'
      path: '/profile'
      fullPath: '/$locale/smartbanking/profile'
      preLoaderRoute: typeof LocaleSmartbankingProfileRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/payments': {
      id: '/$locale/smartbanking/payments'
      path: '/payments'
      fullPath: '/$locale/smartbanking/payments'
      preLoaderRoute: typeof LocaleSmartbankingPaymentsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/messages': {
      id: '/$locale/smartbanking/messages'
      path: '/messages'
      fullPath: '/$locale/smartbanking/messages'
      preLoaderRoute: typeof LocaleSmartbankingMessagesRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/investments': {
      id: '/$locale/smartbanking/investments'
      path: '/investments'
      fullPath: '/$locale/smartbanking/investments'
      preLoaderRoute: typeof LocaleSmartbankingInvestmentsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/info': {
      id: '/$locale/smartbanking/info'
      path: '/info'
      fullPath: '/$locale/smartbanking/info'
      preLoaderRoute: typeof LocaleSmartbankingInfoRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/documents': {
      id: '/$locale/smartbanking/documents'
      path: '/documents'
      fullPath: '/$locale/smartbanking/documents'
      preLoaderRoute: typeof LocaleSmartbankingDocumentsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/dashboard': {
      id: '/$locale/smartbanking/dashboard'
      path: '/dashboard'
      fullPath: '/$locale/smartbanking/dashboard'
      preLoaderRoute: typeof LocaleSmartbankingDashboardRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/contacts': {
      id: '/$locale/smartbanking/contacts'
      path: '/contacts'
      fullPath: '/$locale/smartbanking/contacts'
      preLoaderRoute: typeof LocaleSmartbankingContactsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/cards': {
      id: '/$locale/smartbanking/cards'
      path: '/cards'
      fullPath: '/$locale/smartbanking/cards'
      preLoaderRoute: typeof LocaleSmartbankingCardsRouteImport
      parentRoute: typeof LocaleSmartbankingRoute
    }
    '/$locale/smartbanking/payments/': {
      id: '/$locale/smartbanking/payments/'
      path: '/'
      fullPath: '/$locale/smartbanking/payments/'
      preLoaderRoute: typeof LocaleSmartbankingPaymentsIndexRouteImport
      parentRoute: typeof LocaleSmartbankingPaymentsRoute
    }
    '/$locale/smartbanking/payments/$paymentId': {
      id: '/$locale/smartbanking/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/$locale/smartbanking/payments/$paymentId'
      preLoaderRoute: typeof LocaleSmartbankingPaymentsPaymentIdRouteImport
      parentRoute: typeof LocaleSmartbankingPaymentsRoute
    }
  }
}

interface LocaleSmartbankingPaymentsRouteChildren {
  LocaleSmartbankingPaymentsPaymentIdRoute: typeof LocaleSmartbankingPaymentsPaymentIdRoute
  LocaleSmartbankingPaymentsIndexRoute: typeof LocaleSmartbankingPaymentsIndexRoute
}

const LocaleSmartbankingPaymentsRouteChildren: LocaleSmartbankingPaymentsRouteChildren =
  {
    LocaleSmartbankingPaymentsPaymentIdRoute:
      LocaleSmartbankingPaymentsPaymentIdRoute,
    LocaleSmartbankingPaymentsIndexRoute: LocaleSmartbankingPaymentsIndexRoute,
  }

const LocaleSmartbankingPaymentsRouteWithChildren =
  LocaleSmartbankingPaymentsRoute._addFileChildren(
    LocaleSmartbankingPaymentsRouteChildren,
  )

interface LocaleSmartbankingRouteChildren {
  LocaleSmartbankingCardsRoute: typeof LocaleSmartbankingCardsRoute
  LocaleSmartbankingContactsRoute: typeof LocaleSmartbankingContactsRoute
  LocaleSmartbankingDashboardRoute: typeof LocaleSmartbankingDashboardRoute
  LocaleSmartbankingDocumentsRoute: typeof LocaleSmartbankingDocumentsRoute
  LocaleSmartbankingInfoRoute: typeof LocaleSmartbankingInfoRoute
  LocaleSmartbankingInvestmentsRoute: typeof LocaleSmartbankingInvestmentsRoute
  LocaleSmartbankingMessagesRoute: typeof LocaleSmartbankingMessagesRoute
  LocaleSmartbankingPaymentsRoute: typeof LocaleSmartbankingPaymentsRouteWithChildren
  LocaleSmartbankingProfileRoute: typeof LocaleSmartbankingProfileRoute
  LocaleSmartbankingSavingsRoute: typeof LocaleSmartbankingSavingsRoute
  LocaleSmartbankingSettingsRoute: typeof LocaleSmartbankingSettingsRoute
  LocaleSmartbankingTemplatesRoute: typeof LocaleSmartbankingTemplatesRoute
  LocaleSmartbankingTurnoversRoute: typeof LocaleSmartbankingTurnoversRoute
  LocaleSmartbankingIndexRoute: typeof LocaleSmartbankingIndexRoute
}

const LocaleSmartbankingRouteChildren: LocaleSmartbankingRouteChildren = {
  LocaleSmartbankingCardsRoute: LocaleSmartbankingCardsRoute,
  LocaleSmartbankingContactsRoute: LocaleSmartbankingContactsRoute,
  LocaleSmartbankingDashboardRoute: LocaleSmartbankingDashboardRoute,
  LocaleSmartbankingDocumentsRoute: LocaleSmartbankingDocumentsRoute,
  LocaleSmartbankingInfoRoute: LocaleSmartbankingInfoRoute,
  LocaleSmartbankingInvestmentsRoute: LocaleSmartbankingInvestmentsRoute,
  LocaleSmartbankingMessagesRoute: LocaleSmartbankingMessagesRoute,
  LocaleSmartbankingPaymentsRoute: LocaleSmartbankingPaymentsRouteWithChildren,
  LocaleSmartbankingProfileRoute: LocaleSmartbankingProfileRoute,
  LocaleSmartbankingSavingsRoute: LocaleSmartbankingSavingsRoute,
  LocaleSmartbankingSettingsRoute: LocaleSmartbankingSettingsRoute,
  LocaleSmartbankingTemplatesRoute: LocaleSmartbankingTemplatesRoute,
  LocaleSmartbankingTurnoversRoute: LocaleSmartbankingTurnoversRoute,
  LocaleSmartbankingIndexRoute: LocaleSmartbankingIndexRoute,
}

const LocaleSmartbankingRouteWithChildren =
  LocaleSmartbankingRoute._addFileChildren(LocaleSmartbankingRouteChildren)

interface LocaleRouteChildren {
  LocaleSmartbankingRoute: typeof LocaleSmartbankingRouteWithChildren
  LocaleIndexRoute: typeof LocaleIndexRoute
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleSmartbankingRoute: LocaleSmartbankingRouteWithChildren,
  LocaleIndexRoute: LocaleIndexRoute,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRoute: LocaleRouteWithChildren,
  DevtoolsRoute: DevtoolsRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  MockLoginGatewayRoute: MockLoginGatewayRoute,
  Page2Route: Page2Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
